import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private readonly STORAGE_KEY = 'api_access_token';

  setToken(accessToken: string): void {
    localStorage.setItem(this.STORAGE_KEY, accessToken);
  }

  getToken(): string | null {
    return localStorage.getItem(this.STORAGE_KEY);
  }

  clearToken(): void {
    localStorage.removeItem(this.STORAGE_KEY);
  }

  hasToken(): boolean {
    return this.getToken() !== null;
  }
}
